import { CustomerSetFitAction } from '../reducers/customerFitReducer'

export const customerSetFitAction = (
  payload: CustomerSetFitAction['payload']
): CustomerSetFitAction => ({
  type: 'CUSTOMER_SET_FIT',
  payload
})
